import { Outlet, useLocation } from 'react-router-dom';
import backgroundImage from '../assets/img/top-banner.jpg'
import { HeaderPage } from './header/header-page';
import ExAds from '../assets/img/ex-ads.png'
import guru from "../assets/img/contacts-gurauto-dark.jpg";
import { useEffect } from 'react';


export const MainLayout = () => {
  const location = useLocation();
  const isMainPage = location.pathname === '/';




  useEffect(() => {
    if (!isMainPage) {


      window.scrollTo(0, 0);
    }
  }, [location.pathname]);



  return (<div>
    <HeaderPage isMain={isMainPage} />
    <main className={`max-w-[1280px] mx-auto min-h-screen flex flex-col md:flex-row gap-4 items-justify-between ${!isMainPage ? 'mt-[6rem]' : ''} px-2 lg:px-0 md:justify-between`}>
      <div className={`md:flex-grow ${isMainPage ? '' : 'max-w-[920px]'} w-full md:w-auto`}>
        <Outlet/>
      </div>

      {!isMainPage && (
        <div className={'flex flex-col rounded-lg w-[296px] gap-5 mb-5 self-center md:self-auto'}>
          <div className={'rounded-lg h-96'} style={{ backgroundImage: `url(${guru})`, backgroundRepeat: "no-repeat", backgroundPosition: 'center' }}>
          </div>
          <div className={'rounded-lg h-64'} style={{ backgroundImage: `url(${ExAds})`, backgroundRepeat: "no-repeat",  backgroundPosition: 'center' }}>
          </div>
        </div>
      )}
    </main>

    <footer className="mt-auto"
            style={{backgroundImage: `url(${backgroundImage})`}}>
      <div className="max-w-[1280px]  mx-auto text-center text-white p-2">
        © 2025 FixAuto
      </div>
    </footer>
  </div>)
}